import { createReducer } from 'redux-act';
import * as actions from '#app/actions/couponDeal';
import type { CouponDealFormPayload } from '#app/actions/couponDeal';

interface CouponDealState {
  modalVisible: boolean;
  form: CouponDealFormPayload;
}

const initialState: CouponDealState = {
  modalVisible: false,
  form: {},
};

const setCouponDealModalVisible = (state: CouponDealState, bool: boolean): CouponDealState => ({
  ...state,
  modalVisible: bool,
});

const closeCouponDealForm = (state: CouponDealState): CouponDealState => ({
  ...state,
  form: {},
  modalVisible: false,
});

const setCouponDealForm = (
  state: CouponDealState,
  form: CouponDealFormPayload
): CouponDealState => ({
  ...state,
  form,
  modalVisible: true,
});

export default createReducer<CouponDealState>(
  {
    [actions.setCouponDealModalVisible.getType()]: setCouponDealModalVisible,
    [actions.setCouponDealForm.getType()]: setCouponDealForm,
    [actions.closeCouponDealForm.getType()]: closeCouponDealForm,
  },
  initialState
);
